/**
 * Cross-app channel announcing that the shell finished reconnecting a
 * calendar/account integration.
 *
 * The shell owns the reconnect flow, but it doesn't know which MFEs render
 * account health state that depends on the outcome. This channel lets any
 * MFE listen for a successful reconnect and refetch its own health data,
 * without the shell reaching into app internals and without threading the
 * result through single-spa `customProps`.
 *
 * Open/close of the reconnect flow is **not** carried on this channel — that
 * goes through the canonical `reconnect` query param (see
 * `reconnectParam.ts`), the same rule `eventDraftChannel.ts` uses for the
 * composer's `event` param. This channel only carries the *outcome* of a
 * reconnect attempt that already finished.
 *
 * ******* DO NOT MAKE BACKWARDS INCOMPATIBLE CHANGES *******
 * Shell and apps deploy independently. Renaming the channel constant or
 * removing a payload field can silently break listeners or emitters that
 * have not yet been redeployed.
 *
 * Safe changes:
 *   - Add a new optional field to `ReconnectSucceededDetail`.
 *
 * Unsafe changes:
 *   - Rename or remove the channel constant.
 *   - Remove or rename a field on `ReconnectSucceededDetail`.
 *   - Change a field's type or semantics.
 *
 * If an incompatible change is unavoidable, introduce a new constant
 * (`dashboard:reconnect:succeeded:v2`) and run both for at least one release.
 */
/** The window CustomEvent name used as the transport. */
export var RECONNECT_SUCCEEDED_CHANNEL = 'dashboard:reconnect:succeeded';
